module.exports = __webpack_public_path__ + "img/plus-disabled.ef17666b.png";